export const getTicketTypeGroupAndName = (ticketTypeFullName = '') => {
  const nameArray = (ticketTypeFullName || '').split(/\[|\]/)
  const ticketTypeGroupName = nameArray[1] || ''
  const ticketTypeName = nameArray[2] || ''

  return { ticketTypeName, ticketTypeGroupName }
}
